/**
 * El último día hábil de un mes: sin sábados, domingos ni los feriados cargados.
 *
 * Es la misma regla que aplica el servidor al emitir (`VencimientoDeLaFactura`); aquí solo sirve
 * para enseñar, en la pantalla de feriados, cómo quedan los vencimientos del año.
 *
 * @param mes de 1 a 12
 * @param feriados fechas «AAAA-MM-DD»
 */
export function ultimoDiaHabil(anio: number, mes: number, feriados: ReadonlySet<string>): string {
  const ultimo = new Date(Date.UTC(anio, mes, 0)).getUTCDate();
  for (let dia = ultimo; dia >= 1; dia--) {
    const fecha = new Date(Date.UTC(anio, mes - 1, dia));
    const semana = fecha.getUTCDay();
    const iso = fecha.toISOString().slice(0, 10);
    if (semana !== 0 && semana !== 6 && !feriados.has(iso)) {
      return iso;
    }
  }
  return `${anio}-${String(mes).padStart(2, '0')}-${String(ultimo).padStart(2, '0')}`;
}

const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

/** «miércoles» para «2026-11-11». */
export function diaDeLaSemana(iso: string): string {
  return DIAS[new Date(`${iso}T12:00:00Z`).getUTCDay()] ?? '';
}

export function esFinDeSemana(iso: string): boolean {
  const dia = new Date(`${iso}T12:00:00Z`).getUTCDay();
  return dia === 0 || dia === 6;
}
